import { render, staticRenderFns } from "./BaseAddressCader.vue?vue&type=template&id=51dc3209&scoped=true"
import script from "./BaseAddressCader.vue?vue&type=script&lang=js"
export * from "./BaseAddressCader.vue?vue&type=script&lang=js"
import style0 from "./BaseAddressCader.vue?vue&type=style&index=0&id=51dc3209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_26f79dc07a063b5c44cf61f12066c2ef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dc3209",
  null
  
)

export default component.exports